import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { BodyMeasurement } from '../../api/services/dd_panel_body_measurements/types.ts'
import BodyMeasurementsTable from '../../components/bodyMeasurements/BodyMeasurementsTable.tsx'
import BodyPartsTable from '../../components/bodyMeasurements/BodyPartsTable.tsx'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import { useBodyParts } from '../../hooks/useBodyParts.ts'

const PatientBodyMeasurementsDetails = () => {
  const navigate = useNavigate()
  const { patientProfileId } = useParams<{
    patientProfileId: string
  }>()

  const {
    loading,
    prepareFlatMeasurementParts,
    bodyParts,
    flatMeasurementBodyPartsArray
  } = useBodyParts()

  const location = useLocation()

  const patientFullName = location.state?.patientFullName

  !patientFullName ? navigate(`/patient-profile/${patientProfileId}`) : null

  const [bodyMeasurements, setBodyMeasurements] = useState<
    BodyMeasurement[] | null
  >(null)

  const [showForm, setShowForm] = useState<boolean>(false)

  const getFlatMeasurementBodyParts = async () => {
    await prepareFlatMeasurementParts(bodyMeasurements)
  }

  useEffect(() => {
    if (bodyMeasurements) getFlatMeasurementBodyParts()
  }, [bodyMeasurements])

  return (
    <React.Fragment>
      <Breadcrumbs
        pageName="Pomiary pacjenta"
        breadcrumbs={[
          { label: 'Pacjenci', path: '/patient-profile' },
          {
            label: patientFullName,
            path: `/patient-profile/${patientProfileId}`
          },
          { label: 'Pomiary pacjenta' }
        ]}
      />

      <div className={'flex flex-col gap-4'}>
        <Card>
          <Card.Title>
            <div
              className={classNames('flex justify-between items-center gap-2')}
            >
              {showForm ? 'Wprowadź pomiary' : 'Pomiary'}
              <Button
                variant="filled"
                size="medium"
                color={'primary'}
                type="button"
                onClick={() => setShowForm(!showForm)}
                className={showForm ? 'hidden' : 'block'}
              >
                Dodaj pomiar
              </Button>
            </div>
          </Card.Title>

          <Card.Body className="flex flex-col">
            <BodyMeasurementsTable
              patient_profile={Number(patientProfileId)}
              formAvailable
              showForm={showForm}
              setShowForm={setShowForm}
              setBodyMeasurements={setBodyMeasurements}
              bodyParts={bodyParts}
              formOnStart={
                (bodyMeasurements && bodyMeasurements.length === 0) ?? false
              }
            />
          </Card.Body>
        </Card>

        <Card>
          <Card.Title>{'Obwody ciała'}</Card.Title>
          <Card.Body className="flex flex-col">
            <BodyPartsTable
              loading={loading}
              flatBodyMeasurements={flatMeasurementBodyPartsArray}
              bodyParts={bodyParts}
            />
          </Card.Body>
        </Card>
      </div>
    </React.Fragment>
  )
}

export default PatientBodyMeasurementsDetails
